import { Chip } from '@jotpsych/ui';

import { payerStateLabel, STATE_TOKENS } from '../stateTokens';
import type { PayerAudience, PayerState } from '../types';

export interface StateChipProps {
  state: PayerState;
  audience?: PayerAudience;
  /** Override the default state label (e.g. a summary chip prefixes a count). */
  label?: string;
}

/**
 * A single payer's folded state, rendered as the design's status pill on top
 * of the shared Chip (variant="soft", size="xSmall"): 11px/700, fully rounded,
 * with the state's tone applied via `sx`.
 * Covers every state: needs_us, needs_customer, waiting, ready, canceled, live.
 */
export function StateChip({ state, label, audience }: StateChipProps) {
  const tokens = STATE_TOKENS[state];
  return (
    <Chip
      label={label ?? payerStateLabel(state, audience)}
      variant="soft"
      size="xSmall"
      sx={{
        height: 22,
        borderRadius: '999px',
        backgroundColor: tokens.bg,
        borderColor: tokens.border,
        color: tokens.text,
        border: '1px solid',
        fontSize: '11px',
        fontWeight: 700,
        letterSpacing: '0.03em',
        '& .MuiChip-label': { paddingLeft: '9px', paddingRight: '9px' },
      }}
    />
  );
}
